import React, { useEffect, useState } from 'react';
import { Alert } from 'reactstrap';
import cx from 'classnames';
import EvaluasiListTable from './EvaluasiListTable';

import s from '../Users.module.scss';

const EvaluasiListPage = () => {
  const [promoAlert, setPromoAlert] = useState(false);

  const showPromoAlert = () => setPromoAlert(true);

  useEffect(() => {
    setTimeout(() => {
      showPromoAlert();
    }, 100);
  });

  return (
    <div>
      <div className='page-top-line'>
        <h2 className='page-title'>
          Evaluasi <span className='fw-semi-bold'>Penerima Bantuan</span>
        </h2>
        <Alert
          color='primary'
          className={cx(s.promoAlert, { [s.showAlert]: promoAlert })}
        >
          Aplikasi ini terintegrasi ke{' '}
          <a
            className='text-white font-weight-bold'
            rel='noreferrer noopener'
            href=''
            target='_blank'
          >
            Rote Smart Service
          </a>{' '}
          integration!
        </Alert>
      </div>
      <EvaluasiListTable />
    </div>
  );
};

export default EvaluasiListPage;
